import { render } from "./ServiceCustomNotification.vue?vue&type=template&id=74736bea"
import script from "./ServiceCustomNotification.vue?vue&type=script&lang=js"
export * from "./ServiceCustomNotification.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__